// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide-arrow_bea48a36 {
  margin: 0;
  padding: 0;
  border: 0;
}
.slide-arrow_bea48a36 {
  border: none;
  cursor: pointer;
  position: absolute;
  z-index: 10;
  top: 0;
  display: flex;
  align-items: center;
  height: 100%;
  width: 3rem;
  padding: 0.667rem;
}
body:not(.with-outline) .slide-arrow_bea48a36 {
  outline: none;
}
.slide-arrow_vertical_bea48a36 {
  top: unset;
  width: 100%;
  height: 3.334rem;
  justify-content: center;
}
.slide-arrow_left_bea48a36 {
  left: 0;
  justify-content: flex-start;
  background: linear-gradient(to right, #fff 0%, #fff 30%, rgba(255,255,255,0) 100%);
}
.slide-arrow_right_bea48a36 {
  right: 0;
  justify-content: flex-end;
  background: linear-gradient(to right, rgba(255,255,255,0) 0%, #fff 70%, #fff 100%);
}
.slide-arrow_top_bea48a36 {
  top: 0;
  background: linear-gradient(to bottom, #fff 0%, #fff 70%, rgba(255,255,255,0) 100%);
}
.slide-arrow_bottom_bea48a36 {
  bottom: 0;
  background: linear-gradient(to top, #fff 0%, #fff 30%, rgba(255,255,255,0) 100%);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"slide-arrow": `slide-arrow_bea48a36`,
	"slide-arrow_vertical": `slide-arrow_vertical_bea48a36`,
	"slide-arrow_left": `slide-arrow_left_bea48a36`,
	"slide-arrow_right": `slide-arrow_right_bea48a36`,
	"slide-arrow_top": `slide-arrow_top_bea48a36`,
	"slide-arrow_bottom": `slide-arrow_bottom_bea48a36`
};
export default ___CSS_LOADER_EXPORT___;
